import { render, staticRenderFns } from "./shelfassetAttr.vue?vue&type=template&id=4505e884&scoped=true"
import script from "./shelfassetAttr.vue?vue&type=script&lang=js"
export * from "./shelfassetAttr.vue?vue&type=script&lang=js"
import style0 from "./shelfassetAttr.vue?vue&type=style&index=0&id=4505e884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505e884",
  null
  
)

component.options.__file = "shelfassetAttr.vue"
export default component.exports